import './App.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './components/layout/home.component';
import Login from './components/layout/login.component';
import Wait from './components/layout/Wait'
import Waitinput from './components/layout/Waitinput'
import Waitview from './components/layout/Waitview'
import MemberList from './components/layout/message.component';
import Waitviewrenewal from './components/ReceptionWaitListView'
import { RecoilRoot } from 'recoil';
import { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import MiniHome from './components/layout/minihome/minihome';
import Reservation from './components/layout/minihome/Reservation';
import LocalHtmlComponent from './components/LocalHtmlComponent';
import FABRealTimeOrder from './components/layout/FABRealTimeOrder';


function App() {  
  const [isDark, setIsDark] = useState(true);
  const location = useLocation();
  const isLoginRoute = location.pathname === '/login';

  return (
    <div className={`App ${isLoginRoute ? 'body-login' : ''}`}>

      
      <RecoilRoot> 
        <Routes>
          
          <Route path="/" element={<Home/>} />
          
          <Route path="/login" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/Waitinput/:clubseq" element={<Waitinput/>} />
          <Route path="/Waitview" element={<Waitview/>} />
          <Route path="/wait/:id" element={<Wait/>} />
          <Route path="/minihome/:clubSeq" element={<MiniHome />} />
          <Route path="/minihome/:clubSeq/reservation" element={<Reservation />} />
          
          <Route path="/LocalHtmlComponent" element={<LocalHtmlComponent/>} />
          <Route path="/realtime-order" element={<FABRealTimeOrder />} />

          {/* <Route path="/:agentSeq/:clubSeq" element={<MemberList />} /> */}
        </Routes>
        
      </RecoilRoot> 
    </div>
  );
}

export default App;
